// // import React from "react";
// // import styled from "styled-components";
// // import {
// //   FaProjectDiagram,
// //   FaUsers,
// //   FaYoutube,
// //   FaLinkedin,
// // } from "react-icons/fa";
// // import { gradients } from "./theme/theme";

// // const StatsWrapper = styled.section`
// //   background: black;
// //   padding: 2rem 1rem;
// //   display: flex;
// //   justify-content: center;
// //   gap: 2rem;
// //   flex-wrap: wrap;
// //   text-align: center;
// //   color: #fff;
// // `;

// // const StatCard = styled.div`
// //   flex: 1;
// //   min-width: 180px;
// //   max-width: 250px;
// //   background: ${gradients.heroBackground};
// //   border-radius: 12px;
// //   padding: 1.5rem;
// //   transition: transform 0.3s ease, background 0.3s ease;
// //   backdrop-filter: blur(10px);

// //   &:hover {
// //     transform: translateY(-5px);
// //     background: rgba(255, 255, 255, 0.1);
// //   }

// //   h2 {
// //     font-size: 2rem;
// //     margin: 0.5rem 0;
// //   }

// //   p {
// //     font-size: 1rem;
// //     color: #ddd;
// //     margin: 0;
// //   }
// // `;

// // const IconWrapper = styled.div`
// //   font-size: 2.5rem;
// //   color: ${({ theme }) => theme.orange};
// // `;

// // const SocialStatsSeparator = () => {
// //   const stats = [
// //     { icon: <FaProjectDiagram />, number: "10+", label: "Projects Delivered" },
// //     { icon: <FaUsers />, number: "3M+", label: "Content Views On YT" },
// //     { icon: <FaYoutube />, number: "17K+", label: "YouTube Subscribers" },
// //     { icon: <FaLinkedin />, number: "19K+", label: "LinkedIn Followers" },
// //   ];

// //   return (
// //     <StatsWrapper>
// //       {stats.map((stat, index) => (
// //         <StatCard key={index}>
// //           <IconWrapper>{stat.icon}</IconWrapper>
// //           <h2>{stat.number}</h2>
// //           <p>{stat.label}</p>
// //         </StatCard>
// //       ))}
// //     </StatsWrapper>
// //   );
// // };

// // export default SocialStatsSeparator;

// import React, { useEffect, useState } from "react";
// import styled, { keyframes } from "styled-components";
// import {
//   FaProjectDiagram,
//   FaUsers,
//   FaYoutube,
//   FaLinkedin,
// } from "react-icons/fa";
// import { gradients } from "./theme/theme";

// // Animation for the number increase
// const fadeUp = keyframes`
//   0% { transform: translateY(10px); opacity: 0; }
//   100% { transform: translateY(0); opacity: 1; }
// `;

// const StatsWrapper = styled.section`
//   background: black;
//   padding: 3rem 1rem;
//   display: flex;
//   justify-content: center;
//   gap: 2rem;
//   flex-wrap: wrap;
//   text-align: center;
//   color: #fff;
// `;

// const StatCard = styled.div`
//   flex: 1;
//   min-width: 180px;
//   max-width: 250px;
//   background: ${gradients.heroBackground};
//   border-radius: 16px;
//   padding: 2rem;
//   transition: all 0.3s ease;
//   backdrop-filter: blur(10px);
//   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
//   animation: ${fadeUp} 0.6s ease forwards;
//   animation-delay: ${(props) => props.delay || 0}s;
//   opacity: 0;

//   &:hover {
//     transform: translateY(-6px) scale(1.03);
//     box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
//   }

//   h2 {
//     font-size: 2.4rem;
//     margin: 0.5rem 0;
//     font-weight: 700;
//   }

//   p {
//     font-size: 1rem;
//     color: #ddd;
//     margin: 0;
//   }
// `;

// const IconWrapper = styled.div`
//   font-size: 2.8rem;
//   color: ${({ theme }) => theme.orange || "#ff6b00"};
// `;

// const SocialStatsSeparator = () => {
//   const stats = [
//     {
//       icon: <FaProjectDiagram />,
//       number: 10,
//       suffix: "+",
//       label: "Projects Delivered",
//     },
//     {
//       icon: <FaUsers />,
//       number: 3,
//       suffix: "M+",
//       label: "Content Views On YT",
//     },
//     {
//       icon: <FaYoutube />,
//       number: 17,
//       suffix: "K+",
//       label: "YouTube Subscribers",
//     },
//     {
//       icon: <FaLinkedin />,
//       number: 19,
//       suffix: "K+",
//       label: "LinkedIn Followers",
//     },
//   ];

//   const [counts, setCounts] = useState(stats.map(() => 0));

//   useEffect(() => {
//     stats.forEach((stat, index) => {
//       let start = 0;
//       const end = stat.number;
//       const duration = 1500; // ms
//       const increment = end / (duration / 30);
//       const timer = setInterval(() => {
//         start += increment;
//         if (start >= end) {
//           start = end;
//           clearInterval(timer);
//         }
//         setCounts((prev) => {
//           const updated = [...prev];
//           updated[index] = Math.floor(start);
//           return updated;
//         });
//       }, 30);
//     });
//   }, []);

//   return (
//     <StatsWrapper>
//       {stats.map((stat, index) => (
//         <StatCard key={index} delay={index * 0.15}>
//           <IconWrapper>{stat.icon}</IconWrapper>
//           <h2>
//             {counts[index]}
//             {stat.suffix}
//           </h2>
//           <p>{stat.label}</p>
//         </StatCard>
//       ))}
//     </StatsWrapper>
//   );
// };

// export default SocialStatsSeparator;

import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import {
  FaProjectDiagram,
  FaUsers,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { gradients } from "./theme/theme";

/* --- Animations --- */
const fadeUp = keyframes`
  0% { transform: translateY(20px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

/* Main section */
const StatsSection = styled.section`
  background: black;
  padding: 4rem 1rem;
  overflow: hidden;
`;

/* Flex wrapper for cards */
const StatsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
`;

/* Card style */
const StatCard = styled.div`
  flex: 1;
  min-width: 180px;
  max-width: 250px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 18px;
  padding: 2rem;
  text-align: center;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  animation: ${fadeUp} 0.6s ease forwards;
  animation-delay: ${(props) => props.delay || 0}s;
  opacity: 0;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-8px) scale(1.05);
    box-shadow: 0 0 25px rgba(255, 122, 24, 0.3),
      0 0 40px rgba(255, 0, 102, 0.25);
  }

  h2 {
    font-size: 2.4rem;
    margin: 0.5rem 0;
    font-weight: 700;
    background: linear-gradient(90deg, #ff7a18, #ff0066);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1rem;
    color: #ccc;
    margin: 0;
  }
`;

/* Icon with gradient text */
const IconWrapper = styled.div`
  font-size: 2.8rem;
  margin-bottom: 0.6rem;
  background: linear-gradient(135deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export default function SocialStatsSeparator() {
  const stats = [
    {
      icon: <FaProjectDiagram />,
      number: 10,
      suffix: "+",
      label: "Projects Delivered",
    },
    {
      icon: <FaUsers />,
      number: 3,
      suffix: "M+",
      label: "Content Views On YT",
    },
    {
      icon: <FaYoutube />,
      number: 17,
      suffix: "K+",
      label: "YouTube Subscribers",
    },
    {
      icon: <FaLinkedin />,
      number: 19,
      suffix: "K+",
      label: "LinkedIn Followers",
    },
  ];

  const [counts, setCounts] = useState(stats.map(() => 0));

  useEffect(() => {
    stats.forEach((stat, index) => {
      let start = 0;
      const end = stat.number;
      const duration = 1500;
      const increment = end / (duration / 30);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(timer);
        }
        setCounts((prev) => {
          const updated = [...prev];
          updated[index] = Math.floor(start);
          return updated;
        });
      }, 30);
    });
  }, []);

  return (
    <StatsSection>
      <StatsWrapper>
        {stats.map((stat, index) => (
          <StatCard key={index} delay={index * 0.15}>
            <IconWrapper>{stat.icon}</IconWrapper>
            <h2>
              {counts[index]}
              {stat.suffix}
            </h2>
            <p>{stat.label}</p>
          </StatCard>
        ))}
      </StatsWrapper>
    </StatsSection>
  );
}
